import { useEffect } from "react";
import { BrowserRouter, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { BaseLayout } from "./components/layouts/BaseLayout";
import { trpc } from "./lib/trpc";
import { FolderDetail } from "./pages/Folders/Detail";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { OfficeDetail } from "./pages/Offices/Detail";
import { PasswordForgot } from "./pages/Password/Forgot";
import { PasswordReset as PasswordResetPage } from "./pages/Password/Reset";
import { ProjectDetail } from "./pages/Projects/Detail";
import { AccountSetting } from "./pages/Settings/Account";
import { Logout } from "./pages/Settings/Logout";
import { PasswordReset } from "./pages/Settings/PasswordReset";
import { UsersSetting } from "./pages/Settings/Users";
import { UsersEditSetting } from "./pages/Settings/Users/Edit";
import { UsersNewSetting } from "./pages/Settings/Users/New";

const RequireNoAuth = () => {
  const navigate = useNavigate();
  const getAuthed = trpc.authed.useQuery();

  useEffect(() => {
    if (!getAuthed.isLoading) {
      const authed = getAuthed.data;
      if (authed) {
        navigate("/");
      }
    }
  }, [getAuthed.isLoading, getAuthed.data, navigate]);

  if (getAuthed.isLoading) return null;

  return <Outlet />;
};

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Home />} />
          <Route path="/offices/:id" element={<OfficeDetail />} />
          <Route path="/folders/:id" element={<FolderDetail />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/settings/account" element={<AccountSetting />} />
          <Route path="/settings/password-reset" element={<PasswordReset />} />
          <Route path="/settings/users" element={<UsersSetting />} />
          <Route path="/settings/users/new" element={<UsersNewSetting />} />
          <Route path="/settings/users/:id/edit" element={<UsersEditSetting />} />
          <Route path="/settings/logout" element={<Logout />} />
        </Route>
        <Route element={<RequireNoAuth />}>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<PasswordResetPage />} />
          <Route path="/password-forgot" element={<PasswordForgot />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
